<template>
	<q-btn
		v-if="portal.isAppReady"
		v-show="!portal.shouldHideBackButton()"
		@click="$emit('back')"
		align="left"
		class="btn-fixed-width"
		color="primary"
		icon="keyboard_arrow_left"
		:label="$t(portal.getButtonText(true))"
		id="btnBack"
	/>
	<q-btn
		v-if="!portal.shouldHideSkipButton()"
		@click="$emit('skip')"
		flat
		color="primary"
		:label="$t('portal_btnSkip')"
		class="q-ml-auto"
		id="btnSkip"
	/>
	<q-btn
		v-if="portal.isAppReady"
		v-show="!portal.shouldHideNextButton()"
		@click="$emit('next')"
		align="right"
		class="btn-fixed-width"
		:class="{ 'q-ml-auto': portal.navPageConfig.length ? portal.shouldHideSkipButton() : true } "
		color="primary"
		icon-right="keyboard_arrow_right"
		:label="$t(portal.getButtonText(false))"
		:disable="portal.disableNext"
		id="btnNext"
	/>
</template>

<style lang="less" scoped src="./nav-bar.less"></style>
<script lang="ts" src="./nav-bar.ts"></script>
